import { PageTitle } from "../components/StyledElements"
import React from "react"

export const NotImplemented = (): React.ReactElement => {
  return <PageTitle>{"Cette page est en cours de construction..."}</PageTitle>
}
